import layout from "@/layouts/dashboard";

export default [
    {
        path: "/dashboard/assets",
        name: "dashboard-assets",
        component: layout,
        redirect: {
            name: "dashboard-assets-benefits",
        },
        children: [
            // 全部权益
            {
                path: "benefits",
                name: "dashboard-assets-benefits",
                component: () => import("@/views/assets/benefits.vue"),
                meta: {
                    titleKey: "common.routes.benefitsTitle",
                    descKey: "common.routes.benefitsDesc",
                },
            },
            {
                path: "history/:slug",
                name: "dashboard-assets-benefits-history",
                component: () => import("@/views/assets/history.vue"),
                meta: {
                    titleKey: "common.routes.benefitsTitle",
                    descKey: "common.routes.benefitsDesc",
                },
            },
            // 兑换码
            {
                path: "code",
                name: "dashboard-assets-code",
                component: () => import("@/views/assets/code.vue"),
                meta: {
                    titleKey: "common.routes.codeTitle",
                    descKey: "common.routes.codeDesc",
                },
            },
            {
                path: "purchase/:slug",
                name: "dashboard-assets-purchase",
                component: () => import("@/views/assets/purchase.vue"),
                meta: {
                    titleKey: "common.routes.purchaseTitle",
                    descKey: "common.routes.purchaseDesc",
                },
            },
        ],
    },
];
